import Button from '@components/atoms/button';
import { BodyRegular, H1 } from '@components/atoms/typography';
import type { MarketingCopyAsset, MarketingCopyHomepage } from '@lib/sanity';

type HomepageHeroProps = {
  copy: MarketingCopyHomepage;
};

const buildVideoSource = (url: string, startTime: number | undefined): string =>
  startTime !== undefined && startTime > 0 ? `${url}#t=${startTime}` : url;

const HERO_ASSET_CLASSES =
  'w-auto h-auto max-w-full max-h-[60vh] lg:max-w-3xl lg:max-h-[500px] xl:max-w-4xl rounded-lg';

const HeroAsset = ({ asset }: { asset: MarketingCopyAsset }) => {
  if (asset.kind === 'video') {
    return (
      <video
        controls
        loop
        muted
        autoPlay={true}
        preload={'auto'}
        className={HERO_ASSET_CLASSES}
        src={buildVideoSource(asset.url, asset.startTime)}
        playsInline
      />
    );
  }

  return <img src={asset.url} alt={asset.alt} className={HERO_ASSET_CLASSES} />;
};

const HomepageHero = ({ copy }: HomepageHeroProps) => (
  <div className="my-5 py-5 md:my-8">
    <div className="flex flex-col-reverse md:flex-row justify-evenly">
      <div className="flex flex-col justify-center items-center md:items-start max-w-[625px] px-0 md:px-8 md:pl-10">
        <H1 className="text-center md:text-left mb-1">{copy.title}</H1>
        <BodyRegular className="mb-5">{copy.subtitle}</BodyRegular>
        <div className="inline-flex">
          <Button
            href={copy.ctaHref}
            isLink
            className="inline-flex"
            variant="primary"
          >
            {copy.buttonText}
          </Button>
        </div>
      </div>
      <div className="mb-5 md:mb-0 flex justify-center md:block">
        <HeroAsset asset={copy.asset} />
      </div>
    </div>
  </div>
);

export default HomepageHero;
